import { createErrorHandbook, type ErrorsHandbook, ErrorsHandbookBuilder } from '@/6_shared/api'

export const seanceErrorsHandbook: ErrorsHandbook = createErrorHandbook({
  ...new ErrorsHandbookBuilder(400).withErrorCode(1, 'asd').build(),
  ...new ErrorsHandbookBuilder(404).build()
})
